import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import SiliconEngineering from "./Pages/SiliconEngineering";
import Career from "./Pages/Career";
import Contact from "./Pages/Contact";
import SystemDesign from "./Pages/SystemDesign";
import EmbeddedSolutions from "./Pages/EmbeddedSolutions";
import AI from "./Pages/AI";
import AutomotiveSolutions from "./Pages/AutomotiveSolutions";
import TermsNConditions from "./Pages/TermsNConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";

function App() {
  return (
  <>
       <Router>
         <Routes>
           <Route path="/" element={<Home />} />
           <Route path="/about" element={<About />} />
           <Route path="/services" element={<Services />} />
           <Route path="/siliconengineering" element={<SiliconEngineering />} />
           <Route path="/systemdesign" element={<SystemDesign />} />
           <Route path="/embeddedsolutions" element={<EmbeddedSolutions />} />
           <Route path="/artificialintelligence" element={<AI />} />
           <Route path="/automotivesolutions" element={<AutomotiveSolutions />} />


           
           <Route path="/career" element={<Career />} />
           <Route path="/contact" element={<Contact />} />
           <Route path="/terms" element={<TermsNConditions />} />
           <Route path="/privacypolicy" element={<PrivacyPolicy />} />






    
 
         </Routes>
       </Router>
     </>
  );
}

export default App;
